import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'CREATE_ALERT_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [

                m('.modal-body',
                  [
                    m("div", {
                      "class": "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      style: { float: 'right', "padding-bottom": "20px" }
                    },
                      m(modalCloseButton)
                    ),
                    m('form', [
                      m('div.form-group', [
                        m('label', 'Alert Occurrence:'),
                        m('select.form-control', {
                          onchange: (e) => {
                            state.selectedOccurrence = e.target.value;
                          },
                          value: state.alertOccurrence
                        }, [
                          m('option', { value: '' }, 'Select occurrence'),
                          m('option', { value: 'reccurent' }, 'Reccurent'),
                          m('option', { value: 'one-off' }, 'One-Off')
                        ]),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Alert Determinant:'),
                        m('select.form-control', {
                          onchange: (e) => state.alertDeterminant = e.target.value,
                          value: state.alertDeterminant
                        }, [
                          m('option', { value: '' }, 'Select determinant'),
                          m('option', { value: 'time' }, 'Time'),
                          m('option', { value: 'distance' }, 'Distance')
                        ]),
                      ]),
                      m("br"),
                      state.alertDeterminant == 'time' 
                      ? m('div.form-group.row', [
                        m('.col-sm-6', [
                          m('label', 'Time Value:'),
                          m('input.form-control', {
                            type: 'number',
                            onchange: (e) => state.alertDuration = e.target.value,
                            value: state.alertDuration
                          }),
                        ]),
                        m('.col-sm-6', [
                          m('label', 'Time Unit:'),
                          m('input.form-control', {
                            type: 'number',
                            onchange: (e) => state.alertFrequency = e.target.value,
                            value: state.alertFrequency
                          }),
                        ]),
                      ]) 
                      : m('div.form-group.row', [
                        m('.col-sm-6', [
                          m('label', 'Distance Value:'),
                          m('input.form-control', {
                            type: 'number',
                            onchange: (e) => state.alertDuration = e.target.value,
                            value: state.alertDuration
                          }),
                        ]),
                        m('.col-sm-6', [
                          m('label', 'Distance Unit:'),
                          m('input.form-control', {
                            type: 'number',
                            onchange: (e) => state.alertFrequency = e.target.value,
                            value: state.alertFrequency
                          }),
                        ]),
                      ]),

                    ]),
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-primary.btn-block[type="button"][class="w-100"]', {
                      onclick() {
                        modal.hide();
                        selectVehicleModal.show()
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
